import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

export const startCall = createAsyncThunk(
  "calls/startCall",
  async ({ calleeId, offer }: { calleeId: string; offer: any }, { rejectWithValue }) => {
    try {
      const response: any = await api.create("/api/calls", { calleeId, offer });
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getPendingCalls = createAsyncThunk(
  "calls/getPendingCalls",
  async (_, { rejectWithValue }) => {
    try {
      const response: any = await api.get("/api/calls/pending");
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const answerCall = createAsyncThunk(
  "calls/answerCall",
  async ({ callId, answer }: { callId: string; answer: any }, { rejectWithValue }) => {
    try {
      const response: any = await api.create(`/api/calls/${callId}/answer`, { answer });
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const sendCandidates = createAsyncThunk(
  "calls/sendCandidates",
  async (
    {
      callId,
      fromRole,
      candidates,
    }: { callId: string; fromRole: "caller" | "callee"; candidates: any[] },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await api.create(`/api/calls/${callId}/candidates`, {
        fromRole,
        candidates,
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getCandidates = createAsyncThunk(
  "calls/getCandidates",
  async (
    { callId, forRole, sinceTs }: { callId: string; forRole: "caller" | "callee"; sinceTs: number },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await api.get(`/api/calls/${callId}/candidates`, { forRole, sinceTs });
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getCallStatus = createAsyncThunk(
  "calls/getCallStatus",
  async ({ callId }: { callId: string }, { rejectWithValue }) => {
    try {
      const response: any = await api.get(`/api/calls/${callId}/status`);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const endCall = createAsyncThunk(
  "calls/endCall",
  async ({ callId }: { callId: string }, { rejectWithValue }) => {
    try {
      const response: any = await api.create(`/api/calls/${callId}/end`, {});
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);


